<template lang="pug">
.RakugoTop
  .content
    .title 噺家になろう
    .startButton(
      :class="{'startButton--disabled': isEffectSoundMuted}"
      v-menuClickSound
      v-menuHoverSound
      @click="handleStartButtonClick"
    ) 始める
    .notice(v-if="isEffectSoundMuted") 始めるには効果音を有効にする必要があります
  km-loading-overlay(
    v-if="assetLoaded === false"
    :queuedAssets="assets"
    :loadedAssets="loadedAssets"
  )
  km-footer(
    backPath="/speedup/select"
    title="噺家になろう"
    :homeButtonEnabled="true"
    :challengeResult="challengeResult"
  )
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'speedup-select-page',
  components: {},
  data() {
    return {
      assetLoaded: null,
      assets: [
        { type: 'image', path: require('@/assets/speedup/rakugo/bg.png') },
        {
          type: 'image',
          path: require('@/assets/speedup/rakugo/hanashika.png')
        },
        { type: 'sound', path: '/app/static/speedup/rakugo/end_1.mp3' },
        { type: 'sound', path: '/app/static/speedup/rakugo/end_2.mp3' },
        { type: 'sound', path: '/app/static/speedup/rakugo/laugh_small.mp3' },
        { type: 'sound', path: '/app/static/speedup/rakugo/laugh_normal.mp3' },
        { type: 'sound', path: '/app/static/speedup/rakugo/laugh_large.mp3' }
      ]
    }
  },
  computed: {
    ...mapState('User', {
      rank: state => state.rank,
      lvl: state => state.lvl,
      exp: state => state.exp,
      progress: state => state.progress,
      point: state => state.point,
      account: state => state.account,
      challengeResult: state => state.challenge_result,
      isEffectSoundMuted: state => state.isEffectSoundMuted
    }),
    ...mapState('Assets', {
      loadedAssets: state => state.assets
    })
  },
  methods: {
    ...mapActions('Assets', ['fetchAssets', 'isAssetLoaded']),
    async load() {
      try {
        this.assetLoaded = await this.isAssetLoaded('speedupRakugo')
        await this.fetchAssets({
          currentPage: 'speedupRakugo',
          assets: this.assets
        })
        setTimeout(() => {
          this.assetLoaded = true
        }, 500)
      } catch (e) {
        alert('読み込みエラー')
        this.$router.push('/')
      }
    },
    handleStartButtonClick() {
      this.$router.push('/speedup/rakugo/select')
    }
  },
  async mounted() {
    await this.load()
  }
}
</script>

<style lang="scss" scoped>
.RakugoTop {
  width: 100%;
  height: 100%;
  color: #fff;
}

.content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: calc(100% - 80px);
  font-size: 3rem;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    display: block;
    width: 100%;
    height: 100%;
    background: url(../../../assets/speedup/rakugo/bg.png) center center
      no-repeat;
    background-size: cover;
    z-index: -1;
    filter: blur(5px);
  }
}

.title {
  margin: 0 0 0.5em 0;
  font-size: 72px;
  text-shadow: 0px 0px 10px rgba(82, 18, 119, 0.9);
}

.startButton {
  padding: 15px 60px;
  background: rgba(82, 18, 119, 0.9);
  color: #fff;
  border-radius: 50px;
  transition-property: background, color, padding, transform;

  &:hover {
    padding: 15px 100px;
  }
  &:active {
    transform: scale(0.9);
  }

  &--disabled {
    background: #eee;
    color: #ccc;
    pointer-events: none;
  }
}

.notice {
  position: absolute;
  bottom: 200px;
  padding: 5px 30px;
  background: orange;
  border-radius: 30px;
}
</style>
